/// /////////////////////////////////////////////////////////////////////
const fontStyles = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: '24px'
};
const statusOptions = [{
  value: 'sent',
  label: 'Sent'
}, {
  value: 'completed',
  label: 'Completed'
}, {
  value: 'submitted',
  label: 'Submitted'
}, {
  value: 'waived',
  label: 'Waived'
}];

export { fontStyles, statusOptions };
